<template>
  <div class="ct" :style="{'background': 'url('+backgroundImg+') center 0px / cover no-repeat',width:'100%',height:'100%'}">
    <router-view class="entrance" style="position:relative;width:100%;height:100%;"></router-view>
  </div>
</template>

<script>
export default {
  data () {
    return {
      backgroundImg: '',
      defaultImg: require('../../assets/images/login-bg@2x.png'),
    }
  },
  created () {
  },
  mounted() {
    setTimeout(()=>{
      this.backgroundImg = localStorage.getItem('loginBackgroundImg') || this.defaultImg;
    }, 500)
  },
}
</script>
<style lang="stylus" scoped>
// .entrance
//   width: 100%
//   height: 100vh
//   position relative
// .ct
//   width 100%
//   height 100%
</style>
